// src/contexts/StripeContext.js
import React, { createContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

export const StripeContext = createContext();


export const StripeProvider = ({ children }) => (
  <Elements stripe={stripePromise}>
    <StripeContext.Provider value={{}}>
      {children}
    </StripeContext.Provider>
  </Elements>
);
